import { Directive, ViewContainerRef, OnInit } from '@angular/core';

@Directive({
  selector: '[dynamic-navs]'
})
export class DynamicNavsDirective implements OnInit  {
  constructor(public viewContainer: ViewContainerRef) {}

  ngOnInit(): void {
    // console.log (' inicializando DynamicNavsDirective ');
  }
}

